export default __webpack_public_path__ + "static/media/popular4.b25db9d5.png";